/**
 * Electrical Installation Condition Report (EICR) - Default Blank State
 */

const today = new Date().toISOString().split('T')[0];

export default {
  reportDetails: {
    reportNumber: `EICR-${Date.now()}`,
    reportDate: today,
    purposeOfReport: '',
    inspectionTypeLabel: 'Periodic Inspection'
  },
  client: {
    clientName: '',
    clientAddress: ''
  },
  property: {
    propertyAddress: '',
    propertyType: '',
    numberOfBedrooms: '',
    estimatedAgeOfInstallation: ''
  },
  installation: {
    installationAddress: '',
    extentLimitations: '',
    mainSupply: '',
    earthingArrangement: '',
    externalZe: ''
  },
  distributionBoards: [
    {
      boardName: 'DB1',
      boardLocation: '',
      numberOfWays: '',
      mainSwitch: '',
      rcdPresent: '',
      rcdType: ''
    }
  ],
  circuits: [
    {
      circuitNumber: '1',
      boardName: 'DB1',
      circuitDescription: '',
      location: '',
      phase: '',
      protectiveDevice: '',
      deviceRating: '',
      maxZs: '',
      measuredZs: '',
      rcdType: '',
      rcdTripTime1x: '',
      rcdTripTime5x: '',
      insulationResistance: '',
      testResult: ''
    }
  ],
  observations: [
    {
      observationCode: '',
      observationDetails: '',
      observationLocation: '',
      photo: '',
      limitations: 'None'
    }
  ],
  recommendation: {
    summaryCondition: '',
    recommendations: ''
  },
  declaration: {
    engineerName: '',
    engineerCardNumber: '',
    companyName: '',
    engineerSignature: '',
    clientSignature: ''
  }
};